import styled from 'styled-components';

import { Button, Drawer } from '@gympass/yoga';

import { DrawerHeaderProps } from './types';

export const DrawerContainer = styled(Drawer)`
  font-style: normal;
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.yoga.spacing.zero};
  overflow-y: auto;
`;

export const DrawerHeader = styled.div<DrawerHeaderProps>`
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  ${({ isShowArrowLeftIcon }) =>
    isShowArrowLeftIcon
      ? `justify-content: space-between;`
      : `justify-content: flex-end;`};
  align-items: center;
  width: 100%;
  padding-left: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  padding-right: ${({ theme }) => theme.yoga.spacing.small}px;
  height: ${({ theme }) => theme.yoga.spacing.xhuge}px;
`;

export const CloseIcon = styled(Button.Icon)`
  width: ${({ theme }) => theme.yoga.spacing.small}px;
  height: ${({ theme }) => theme.yoga.spacing.small}px;
`;

export const ArrowLeftIcon = styled(Button.Icon)`
  width: ${({ theme }) => theme.yoga.spacing.medium}px;
  height: ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const DrawerContent = styled(Drawer.Content)`
  padding-left: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  padding-right: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
`;
